import React from "react";

const Bars3 = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-bars-3"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-bars-3"
      viewBox="0 0 20 20"
      width={_width}
      {...props}
    >
      <path d="M2 4.75A.75.75 0 0 1 2.75 4h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.75ZM2 10a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 10Zm0 5.25a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Z" />
    </svg>
  );
};

export default Bars3;
